import { render } from "./LowStockMessage.vue?vue&type=template&id=266ac7d9&scoped=true"
import script from "./LowStockMessage.vue?vue&type=script&lang=js"
export * from "./LowStockMessage.vue?vue&type=script&lang=js"

import "./LowStockMessage.vue?vue&type=style&index=0&id=266ac7d9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266ac7d9"]])

export default __exports__